import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { mainTable } from "../css/Common";
import { BindPostAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { KPYheaderData } from "../components/HeaderAttribute";
import TableGrid from "../components/Table";
import { useLocation } from "react-router-dom";
import YearDropdown from "../ReusableComponents/YearDropdown";

const Dashboard = () => {
  const location = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [FPUsers, setFPUsers] = useState([]);
  const [bindNoOfClientsByGenderDB, setBindNoOfClientsByGenderDB] = useState(
    []
  );
  const [noOfClientsByGenderDBColor, setNoOfClientsByGenderDBColor] = useState(
    []
  );
  const noOfClientsByGenderDBColors = noOfClientsByGenderDBColor.map(
    (item) => item.Color
  );
  const [FPUsersColor, setFPUsersColor] = useState([]);
  const colors = FPUsersColor.map((item) => item.Color);
  const [servicesCategory, setServicesCategory] = useState([]);
  const [serviceKeys, setserviceKeys] = useState([]);
  const [servicesNameList, setServicesNameList] = useState({});
  const [servicesNameListColors, setServicesNameListColors] = useState({});
  const [bindCYP, setBindCYP] = useState([]);
  const [abortionClientsData, setAbortionClientsData] = useState([]);
  const [abortionClientsKeys, setAbortionClientsKeys] = useState([]);
  const [abortionClientNameList, setAbortionClientsNameList] = useState({});
  const [abortionClientListColors, setAbortionClientsListColors] = useState({});
  const [marginalizedClientsNameList, setMarginalizedClientsNameList] =
    useState({});
  const [noOfSRHServicesBySDPData, setNoOfSRHServicesBySDPData] = useState([]);
  const [noOfSRHServicesBySDPKeys, setNoOfSRHServicesBySDPKeys] = useState([]);
  const [noOfSRHServicesBySDPList, setNoOfSRHServicesBySDPList] = useState({});
  const [noOfSRHServicesBySDPColors, setNoOfSRHServicesBySDPColors] = useState(
    {}
  );

  const [cypKeys, setCYPKeys] = useState([]);
  const [cypNameList, setCYPNameList] = useState({});
  const [cypNameListColors, setCYPNameListColors] = useState({});
  const [noOfClients, setNoOfClients] = useState([]);
  const [noOfClientsKeys, setNoOfClientsKeys] = useState([]);
  const [NoOfClientsNameList, setNoOfClientsNameList] = useState({});
  const [NoOfClientsListColor, setNoOfClientsListColor] = useState({});
  const [marginalizedClients, setMarginalizedClients] = useState([]);
  const [marginalizedClientsKeys, setMarginalizedClientsKeys] = useState([]);

  const [
    marginalizedClientsNameListColor,
    setMarginalizedClientsNameListColor,
  ] = useState({});

  const [keyPerformanceIndicatorData, setKeyPerformanceIndicatorData] =
    useState([]);
  const [loadingCharts, setLoadingCharts] = useState({
    servicesCategory: true,
    bindCYP: true,
    marginalizedClients: true,
    FPUsers: true,
    noOfClients: true,
    bindNoOfClientsByGenderDB: true,
    noOfSRHServicesBySDPData: true,
    keyPerformanceIndicatorData: true,
  });
  useEffect(() => {
    if (location.pathname === "/dashboard") {
      if (userProfileDatas && userProfileDatas[0]) {
        const currentYear = new Date().getFullYear();
        getDashboardDataFetch(userProfileDatas, currentYear);
      }
    }
  }, [location, userProfileDatas]);

  const getDashboardDataFetch = async (userProfileDatas, year) => {
    if (!userProfileDatas || !userProfileDatas[0]) return;

    const payloadCommon = {
      year: year.toString(),
      mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
      mstBranchId: userProfileDatas[0].MstLocationId,
      mstSdpId: userProfileDatas[0].MstSDPId || 0,
    };

    try {
      await Promise.all([
        // Services Category
        (async () => {
          setLoadingCharts((prev) => ({ ...prev, servicesCategory: true }));
          const response = await BindPostAPI(
            payloadCommon,
            "DashboardAPI/ServicesCategoryDB"
          );
          const formatted = transformData(response.data.Table);
          setServicesCategory(formatted);
          setserviceKeys(
            Object.keys(formatted[0] || {}).filter((k) => k !== "name")
          );
          setLoadingCharts((prev) => ({ ...prev, servicesCategory: false }));
        })(),

        // FP Users
        (async () => {
          setLoadingCharts((prev) => ({ ...prev, FPUsers: true }));
          const response = await BindPostAPI(
            [payloadCommon],
            "DashboardAPI/FPUsersDB"
          );
          setFPUsers(response.data.Table);
          setFPUsersColor(response.data.Table1);
          setLoadingCharts((prev) => ({ ...prev, FPUsers: false }));
        })(),

        // No of Clients
        (async () => {
          setLoadingCharts((prev) => ({ ...prev, noOfClients: true }));
          const response = await BindPostAPI(
            [payloadCommon],
            "DashboardAPI/NoOfClients"
          );
          const formatted = transformNoofclientssData(response.data.Table);
          setNoOfClients(formatted);
          setNoOfClientsKeys(
            Object.keys(formatted[0] || {}).filter((k) => k !== "name")
          );
          setLoadingCharts((prev) => ({ ...prev, noOfClients: false }));
        })(),

        // CYP Data
        (async () => {
          setLoadingCharts((prev) => ({ ...prev, bindCYP: true }));
          const response = await BindPostAPI(
            [payloadCommon],
            "DashboardAPI/CYPDB"
          );
          const formatted = transCYPFormData(response.data.Table);
          setBindCYP(formatted);
          setCYPKeys(
            Object.keys(formatted[0] || {}).filter((k) => k !== "name")
          );
          setLoadingCharts((prev) => ({ ...prev, bindCYP: false }));
        })(),

        // Marginalized Clients
        (async () => {
          setLoadingCharts((prev) => ({ ...prev, marginalizedClients: true }));
          const response = await BindPostAPI(
            payloadCommon,
            "DashboardAPI/MarginalizedClientsDB"
          );
          const formatted = transformMarginalizedClientsData(
            response.data.Table
          );
          setMarginalizedClients(formatted);
          setMarginalizedClientsKeys(
            Object.keys(formatted[0] || {}).filter((k) => k !== "name")
          );
          setLoadingCharts((prev) => ({ ...prev, marginalizedClients: false }));
        })(),

        // Clients by Gender
        (async () => {
          setLoadingCharts((prev) => ({
            ...prev,
            bindNoOfClientsByGenderDB: true,
          }));
          const response = await BindPostAPI(
            [payloadCommon],
            "DashboardAPI/NoOfClientsByGenderDB"
          );
          setBindNoOfClientsByGenderDB(response.data.Table);
          setNoOfClientsByGenderDBColor(response.data.Table1);
          setLoadingCharts((prev) => ({
            ...prev,
            bindNoOfClientsByGenderDB: false,
          }));
        })(),

        // Abortion Clients
        (async () => {
          setLoadingCharts((prev) => ({ ...prev, abortionClientsData: true }));
          const response = await BindPostAPI(
            [payloadCommon],
            "DashboardAPI/AbortionClientsDB"
          );
          const formatted = transformAbortionData(response.data.Table);
          setAbortionClientsData(formatted);
          setAbortionClientsKeys(
            Object.keys(formatted[0] || {}).filter((k) => k !== "name")
          );
          setLoadingCharts((prev) => ({ ...prev, abortionClientsData: false }));
        })(),

        // SRH Services by SDP
        (async () => {
          setLoadingCharts((prev) => ({
            ...prev,
            noOfSRHServicesBySDPData: true,
          }));
          const response = await BindPostAPI(
            [payloadCommon],
            "DashboardAPI/NoOfSRHServicesBySDP"
          );
          const formatted = transformNoOfSRHServicesBySDPData(
            response.data.Table
          );
          setNoOfSRHServicesBySDPData(formatted);
          setNoOfSRHServicesBySDPKeys(
            Object.keys(formatted[0] || {}).filter((k) => k !== "name")
          );
          setLoadingCharts((prev) => ({
            ...prev,
            noOfSRHServicesBySDPData: false,
          }));
        })(),

        // Key Performance Indicator
        (async () => {
          setLoadingCharts((prev) => ({
            ...prev,
            keyPerformanceIndicatorData: true,
          }));
          const response = await BindPostAPI(
            payloadCommon,
            "DashboardAPI/KeyPerformanceIndicatorDB"
          );
          setKeyPerformanceIndicatorData(response?.data?.Table);
          setLoadingCharts((prev) => ({
            ...prev,
            keyPerformanceIndicatorData: false,
          }));
        })(),
      ]);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  function transformData(data) {
    const result = {};
    const servicesList = {};
    const servicesListColors = {};

    data?.forEach((category) => {
      if (!category.CategoryName) {
        // Skip the category if CategoryName is null or undefined
        return;
      }
      const categoryName = category?.CategoryName?.replace(/ /g, "")
        .replace(/\//g, "")
        .replace(/-/g, "");
      servicesList[categoryName] = category?.CategoryName;

      servicesListColors[categoryName] = category?.ServicesCategory_Color;

      for (const [month, value] of Object.entries(category)) {
        if (month !== "CategoryName" && month !== "ServicesCategory_Color") {
          if (!result[month]) {
            result[month] = { name: month };
          }
          result[month][categoryName] = value;
        }
      }
    });
    setServicesNameList(servicesList);
    setServicesNameListColors(servicesListColors);
    return Object.values(result);
  }
  function transformAbortionData(data) {
    const result = {};
    const servicesList = {};
    const servicesListColors = {};

    data?.forEach((category) => {
      if (!category.MTP) {
        // Skip the category if CategoryName is null or undefined
        return;
      }
      const categoryName = category?.MTP?.replace(/ /g, "")
        .replace(/\//g, "")
        .replace(/-/g, "");
      servicesList[categoryName] = category?.MTP;

      servicesListColors[categoryName] = category?.AbortionColor;

      for (const [month, value] of Object.entries(category)) {
        if (month !== "MTP" && month !== "AbortionColor") {
          if (!result[month]) {
            result[month] = { name: month };
          }
          result[month][categoryName] = value;
        }
      }
    });
    setAbortionClientsNameList(servicesList);
    setAbortionClientsListColors(servicesListColors);
    return Object.values(result);
  }
  function transformNoOfSRHServicesBySDPData(data) {
    const result = {};
    const sdpList = {};
    const sdpListColors = {};

    data?.forEach((category) => {
      if (!category.SDPColor) {
        // Skip the category if CategoryName is null or undefined
        return;
      }
      const categoryName = category?.SDPName?.replace(/ /g, "")
        .replace(/\//g, "")
        .replace(/-/g, "");
      sdpList[categoryName] = category?.SDPName;

      sdpListColors[categoryName] = category?.SDPColor;

      for (const [month, value] of Object.entries(category)) {
        if (month !== "SDPColor" && month !== "SDPName") {
          if (!result[month]) {
            result[month] = { name: month };
          }
          result[month][categoryName] = value;
        }
      }
    });
    setNoOfSRHServicesBySDPList(sdpList);
    setNoOfSRHServicesBySDPColors(sdpListColors);
    return Object.values(result);
  }
  const transformMarginalizedClientsData = (data) => {
    const result = {};
    const MarginalizedClientsList = {};
    const MarginalizedClientsColors = {};

    data?.forEach((marginalized) => {
      if (!marginalized.MEClients_en) {
        // Skip the category if CategoryName is null or undefined
        return;
      }
      const marginalizedName = marginalized?.MEClients_en?.replace(/ /g, "")
        .replace(/\//g, "")
        .replace(/-/g, "");
      MarginalizedClientsList[marginalizedName] = marginalized?.MEClients_en;

      MarginalizedClientsColors[marginalizedName] = marginalized?.ME_Color;

      for (const [month, value] of Object.entries(marginalized)) {
        if (month !== "MEClients_en" && month !== "ME_Color") {
          if (!result[month]) {
            result[month] = { name: month };
          }
          result[month][marginalizedName] = value;
        }
      }
    });
    setMarginalizedClientsNameList(MarginalizedClientsList);
    setMarginalizedClientsNameListColor(MarginalizedClientsColors);
    return Object.values(result);
  };

  const transformNoofclientssData = (data) => {
    const result = {};
    const NoofclientsList = {};
    const NoofclientsColors = {};

    data?.forEach((noOfClients) => {
      if (!noOfClients.Total_Clients) {
        // Skip the category if CategoryName is null or undefined
        return;
      }
      const noofclientsName = noOfClients?.Total_Clients?.replace(/ /g, "")
        .replace(/\//g, "")
        .replace(/-/g, "");
      NoofclientsList[noofclientsName] = noOfClients?.Total_Clients;

      NoofclientsColors[noofclientsName] = noOfClients?.Color;

      for (const [month, value] of Object.entries(noOfClients)) {
        if (month !== "MEClients_en" && month !== "ME_Color") {
          if (!result[month]) {
            result[month] = { name: month };
          }
          result[month][noofclientsName] = value;
        }
      }
    });
    setNoOfClientsNameList(NoofclientsList);
    setNoOfClientsListColor(NoofclientsColors);
    return Object.values(result);
  };

  function transCYPFormData(data) {
    const result = {};
    const cypList = {};
    const cypListColors = {};

    data?.forEach((cypdata) => {
      if (!cypdata.CYP) {
        // Skip the category if CategoryName is null or undefined
        return;
      }
      const cypName = cypdata?.CYP?.replace(/ /g, "")
        .replace(/\//g, "")
        .replace(/-/g, "");
      cypList[cypName] = cypdata?.CYP;

      cypListColors[cypName] = cypdata?.Services_Color;

      for (const [month, value] of Object.entries(cypdata)) {
        if (month !== "CYP" && month !== "Services_Color") {
          if (!result[month]) {
            result[month] = { name: month };
          }
          result[month][cypName] = value;
        }
      }
    });
    setCYPNameList(cypList);
    setCYPNameListColors(cypListColors);

    return Object.values(result);
  }
  const abortionTooltip = (value, name) => {
    return [value, abortionClientNameList[name]];
  };

  const renderCustomizedAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="middle"
          fill="#666"
          transform="rotate(-60)"
          fontSize="12"
        >
          {payload.value.substring(0, 3)}
        </text>
      </g>
    );
  };

  const cypTooltip = (value, name) => {
    return [value, cypNameList[name]];
  };

  const formatTooltip = (value, name) => {
    return [value, servicesNameList[name]];
  };

  const marginalizedTooltip = (value, name) => {
    return [value, marginalizedClientsNameList[name]];
  };

  const noOfSRHServicesBySDPTooltip = (value, name) => {
    return [value, noOfSRHServicesBySDPList[name]];
  };

  const handleYearChange = async (year) => {
    await getDashboardDataFetch(userProfileDatas, year);
    //setYear(year);
  };

  const renderSkeleton = (size = "medium") => {
    const sizeClass = {
      small: "skeleton-small",
      medium: "skeleton-medium",
      large: "skeleton-large",
    }[size];

    return <div className={`skeleton ${sizeClass} skeleton-pulse`}></div>;
  };
  return (
    <MainLayout pageName={"1"}>
      <>
        {userProfileDatas[0]?.MstRoleId != 7 ? (
          <div>
            <div class="flex justify-between w-full">
              <div className="flex justify-center items-center text-slate-500 text-2xl font-bold mb-4">
                Dashboard
              </div>
              <div class="flex justify-end ">
                <YearDropdown onYearChange={handleYearChange} />
              </div>
            </div>

            <div className="w-full">
              <div className="md:grid gap-4 mb-6 lg:grid-cols-2 md:grid-cols-2 sm:col-span-1">
                {/* Services Category */}
                {loadingCharts.servicesCategory
                  ? renderSkeleton("large")
                  : servicesCategory?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        Service categories
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={servicesCategory}
                          margin={{ top: 5, right: 20, bottom: 20, left: 0 }}
                        >
                          {serviceKeys?.map((key) => (
                            <Line
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stroke={servicesNameListColors[key]}
                              activeDot={{ r: 8 }}
                            />
                          ))}
                          <XAxis
                            dataKey="name"
                            interval={0}
                            tick={renderCustomizedAxisTick}
                          />
                          <Tooltip formatter={formatTooltip} />
                          <YAxis />
                        </LineChart>
                      </ResponsiveContainer>
                      <div className="mt-4 flex flex-wrap justify-center">
                        {serviceKeys?.map((key) => (
                          <div
                            key={key}
                            className="flex items-center mx-2 my-1"
                          >
                            <div
                              className="w-4 h-4 mr-2"
                              style={{
                                backgroundColor: servicesNameListColors[key],
                              }}
                            ></div>
                            <span>{servicesNameList[key]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* CYP */}
                {loadingCharts.bindCYP
                  ? renderSkeleton("large")
                  : bindCYP?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">CYP</div>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={bindCYP}
                          margin={{ top: 5, right: 20, bottom: 20, left: 0 }}
                        >
                          {cypKeys.map((key) => (
                            <Line
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stroke={cypNameListColors[key]}
                              activeDot={{ r: 8 }}
                            />
                          ))}
                          <XAxis
                            dataKey="name"
                            interval={0}
                            tick={renderCustomizedAxisTick}
                          />
                          <Tooltip formatter={cypTooltip} />
                          <YAxis />
                        </LineChart>
                      </ResponsiveContainer>
                      <div className="mt-4 flex flex-wrap justify-center">
                        {cypKeys.map((key) => (
                          <div
                            key={key}
                            className="flex items-center mx-2 my-1"
                          >
                            <div
                              className="w-4 h-4 mr-2"
                              style={{
                                backgroundColor: cypNameListColors[key],
                              }}
                            ></div>
                            <span>{cypNameList[key]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* Marginalized Clients */}
                {loadingCharts.marginalizedClients
                  ? renderSkeleton("large")
                  : marginalizedClients?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        Marginalized clients
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={marginalizedClients}
                          margin={{ top: 5, right: 20, bottom: 20, left: 0 }}
                        >
                          {marginalizedClientsKeys?.map((key) => (
                            <Line
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stroke={marginalizedClientsNameListColor[key]}
                              activeDot={{ r: 8 }}
                            />
                          ))}
                          <XAxis
                            dataKey="name"
                            interval={0}
                            tick={renderCustomizedAxisTick}
                          />
                          <Tooltip formatter={marginalizedTooltip} />
                          <YAxis />
                        </LineChart>
                      </ResponsiveContainer>
                      <div className="mt-4 flex flex-wrap justify-center">
                        {marginalizedClientsKeys?.map((key) => (
                          <div
                            key={key}
                            className="flex items-center mx-2 my-1"
                          >
                            <div
                              className="w-4 h-4 mr-2"
                              style={{
                                backgroundColor:
                                  marginalizedClientsNameListColor[key],
                              }}
                            ></div>
                            <span>{marginalizedClientsNameList[key]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* FP Users */}
                {loadingCharts.FPUsers
                  ? renderSkeleton("large")
                  : FPUsers?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        FP Users
                      </div>
                      <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                          data={FPUsers}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 80,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="Contraceptive user by method"
                            angle={-45}
                            textAnchor="end"
                            interval={0}
                            height={100}
                          />
                          <YAxis />
                          <Tooltip />
                          <Legend verticalAlign="top" height={36} />
                          <Bar dataKey="First Time User" fill={colors[0]} />
                          <Bar dataKey="Continue user" fill={colors[1]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )}

                {/* No. of Clients */}
                {loadingCharts.noOfClients
                  ? renderSkeleton("large")
                  : noOfClients?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        No. of clients
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={noOfClients.filter(
                            (item) => item.name !== "Color"
                          )}
                          margin={{ top: 5, right: 20, bottom: 20, left: 0 }}
                        >
                          {noOfClientsKeys?.map((key) => (
                            <Line
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stroke={NoOfClientsListColor[key]}
                              activeDot={{ r: 8 }}
                            />
                          ))}
                          <XAxis
                            dataKey="name"
                            interval={0}
                            tick={renderCustomizedAxisTick}
                          />
                          <Tooltip formatter={marginalizedTooltip} />
                          <YAxis />
                        </LineChart>
                      </ResponsiveContainer>
                      <div className="mt-4 flex flex-wrap justify-center">
                        {noOfClientsKeys?.map((key) => (
                          <div
                            key={key}
                            className="flex items-center mx-2 my-1"
                          >
                            <div
                              className="w-4 h-4 mr-2"
                              style={{
                                backgroundColor: NoOfClientsListColor[key],
                              }}
                            ></div>
                            <span>{NoOfClientsNameList[key]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* No. of Abortion Clients */}
                {loadingCharts.abortionClientsData
                  ? renderSkeleton("large")
                  : abortionClientsData?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        Abortion clients
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={abortionClientsData}
                          margin={{ top: 5, right: 20, bottom: 20, left: 0 }}
                        >
                          {abortionClientsKeys.map((key) => (
                            <Line
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stroke={abortionClientListColors[key]}
                              activeDot={{ r: 8 }}
                            />
                          ))}
                          <XAxis
                            dataKey="name"
                            interval={0}
                            tick={renderCustomizedAxisTick}
                          />
                          <Tooltip formatter={abortionTooltip} />
                          <YAxis />
                        </LineChart>
                      </ResponsiveContainer>
                      <div className="mt-4 flex flex-wrap justify-center">
                        {abortionClientsKeys.map((key) => (
                          <div
                            key={key}
                            className="flex items-center mx-2 my-1"
                          >
                            <div
                              className="w-4 h-4 mr-2"
                              style={{
                                backgroundColor:
                                  abortionClientListColors[key],
                              }}
                            ></div>
                            <span>{abortionClientNameList[key]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                {/* No. of Clients by Gender */}
                {loadingCharts.bindNoOfClientsByGenderDB
                  ? renderSkeleton("large")
                  : bindNoOfClientsByGenderDB?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        No. Of Clients By Gender
                      </div>
                      <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                          data={bindNoOfClientsByGenderDB}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 80,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="TotalClients"
                            angle={-45}
                            textAnchor="end"
                            interval={0}
                            height={100}
                          />
                          <YAxis />
                          <Tooltip />
                          <Legend verticalAlign="top" height={36} />
                          <Bar
                            dataKey="Female"
                            fill={noOfClientsByGenderDBColors[0]}
                          />
                          <Bar
                            dataKey="Male"
                            fill={noOfClientsByGenderDBColors[1]}
                          />
                          <Bar
                            dataKey="Other"
                            fill={noOfClientsByGenderDBColors[2]}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )}

                {/* SRH Services by SDP */}
                {loadingCharts.noOfSRHServicesBySDPData
                  ? renderSkeleton("large")
                  : noOfSRHServicesBySDPData?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        SRH services by SDP
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={noOfSRHServicesBySDPData}
                          margin={{ top: 5, right: 20, bottom: 20, left: 0 }}
                        >
                          {noOfSRHServicesBySDPKeys?.map((key) => (
                            <Line
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stroke={noOfSRHServicesBySDPColors[key]}
                              activeDot={{ r: 8 }}
                            />
                          ))}
                          <XAxis dataKey="name" interval={0} />
                          <Tooltip formatter={noOfSRHServicesBySDPTooltip} />
                          <YAxis />
                        </LineChart>
                      </ResponsiveContainer>
                      <div className="mt-4 flex flex-wrap justify-center">
                        {noOfSRHServicesBySDPKeys?.map((key) => (
                          <div
                            key={key}
                            className="flex items-center mx-2 my-1"
                          >
                            <div
                              className="w-4 h-4 mr-2"
                              style={{
                                backgroundColor:
                                  noOfSRHServicesBySDPColors[key],
                              }}
                            ></div>
                            <span>{noOfSRHServicesBySDPList[key]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* Key Performance Indicator Table */}
                {loadingCharts.keyPerformanceIndicatorData
                  ? renderSkeleton("large")
                  : keyPerformanceIndicatorData?.length > 0 && (
                    <div className={mainTable.DashboardShadowBox}>
                      <div className="font-bold flex justify-center">
                        Key Performance Indicator
                      </div>
                      <div className={mainTable.grid1}>
                        <TableGrid
                          className={mainTable.table}
                          headerData={KPYheaderData}
                          tableData={keyPerformanceIndicatorData}
                          tableHeight="h-auto"
                          itemsPerPage={100}
                          currentPage={1}
                        />
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center text-slate-500 text-3xl mb-4">
            Welcome
          </div>
        )}
      </>
    </MainLayout>
  );
};

export default Dashboard;
